import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./VedicStorePage.css";

const VedicStorePage = () => {
  const [activeTab, setActiveTab] = useState("books");
  const navigate = useNavigate();

  // Sample product data
  const productCategories = {
    books: [
      {
        id: 1,
        name: "Bhagavad Gita (Hindi)",
        price: 250,
        image: "/gita-book.jpg",
        description: "Original Sanskrit text with Hindi translation"
      },
      {
        id: 2,
        name: "Vedic Mathematics",
        price: 350,
        image: "/vedic-math.jpg",
        description: "Ancient Indian mathematical techniques"
      }
    ],
    gaushala: [
      {
        id: 3,
        name: "Pure Bilona Ghee",
        price: 500,
        image: "/bilona-ghee.jpg",
        description: "500ml, made from A2 milk using traditional methods"
      },
      {
        id: 4,
        name: "Gobar Dhupbatti",
        price: 150,
        image: "/dhupbatti.jpg",
        description: "Natural cow dung incense sticks (pack of 50)"
      }
    ],
    pooja: [
      {
        id: 5,
        name: "Brass Pooja Thali",
        price: 1200,
        image: "/pooja-thali.jpg",
        description: "Handcrafted brass set for rituals"
      },
      {
        id: 6,
        name: "Rudraksha Mala",
        price: 800,
        image: "/rudraksha.jpg",
        description: "Authentic 108 bead mala"
      }
    ]
  };

  const handleAddToCart = (product) => {
    // Implement cart functionality here
    console.log("Added to cart:", product);
  };

  return (
    <div className="vedic-store-container">
      <div className="store-header">
        <h1>Gurukul Vedic Store</h1>
        <p>Authentic products from our Gurukul tradition</p>
      </div>

      <div className="store-tabs">
        <button 
          className={activeTab === "books" ? "active" : ""}
          onClick={() => setActiveTab("books")}
        >
          Vedic Books
        </button>
        <button 
          className={activeTab === "gaushala" ? "active" : ""}
          onClick={() => setActiveTab("gaushala")}
        >
          Gau-Sampada Products
        </button>
        <button 
          className={activeTab === "pooja" ? "active" : ""}
          onClick={() => setActiveTab("pooja")}
        >
          Pooja Items
        </button>
      </div>

      <div className="products-grid">
        {productCategories[activeTab].map(product => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} />
            <h3>{product.name}</h3>
            <p className="description">{product.description}</p>
            <p className="price">₹{product.price}</p>
            <button 
              className="add-to-cart"
              onClick={() => handleAddToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>

      <div className="store-info">
        <h2>About Our Products</h2>
        <p>
          All our products are made with traditional methods by Gurukul. Proceeds support our educational initiatives and 
          Gau-Seva activities.
        </p>
        
        <div className="features">
          <div className="feature">
            {/* <img src="/handmade-icon.png" alt="Handmade" /> */}
            <h3>Handcrafted</h3>
            <p>Made using traditional techniques</p>
          </div>
          <div className="feature">
            {/* <img src="/natural-icon.png" alt="Natural" /> */}
            <h3>100% Natural</h3>
            <p>No chemicals or artificial additives</p>
          </div>
          <div className="feature">
            {/* <img src="/charity-icon.png" alt="Charity" /> */}
            <h3>Supports Education</h3>
            <p>Profits fund Gurukul operations</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VedicStorePage;